import PropTypes from'prop-types';import {REALMS}from'../../utils/realmUtils.js';import useRealm from'../../hooks/useRealm.js';function RealmSpecific(props) {
  var showFor = props.showFor,
    hideFor = props.hideFor,
    children = props.children;
  var realm = useRealm();

  // Support either a whitelist (showFor) or blacklist (hideFor)
  // If for some reason both were provided, the whitelist takes priority
  if (Array.isArray(showFor) && showFor.includes(realm)) {
    return children;
  }
  if (Array.isArray(hideFor) && !hideFor.includes(realm)) {
    return children;
  }
  return null;
}
RealmSpecific.propTypes = {
  /**
   * A whitelist of realms that the children should be shown for.
   *
   * Only one of showFor or hideFor should be provided.
   * If both are provided, showFor will take precidence.
   */
  showFor: PropTypes.arrayOf(PropTypes.oneOf(Object.values(REALMS))),
  /**
   * A blacklist of realms that the children should not be shown for.
   *
   * Only one of showFor or hideFor should be provided.
   * If both are provided, showFor will take precidence.
   */
  hideFor: PropTypes.arrayOf(PropTypes.oneOf(Object.values(REALMS))),
  children: PropTypes.node.isRequired
};
RealmSpecific.defaultProps = {
  showFor: null,
  hideFor: null,
  children: null
};export{RealmSpecific as default};